import { Lightning } from '@lightningjs/sdk';
import _merge from 'lodash/merge';
import { getInitialStyle, defaultContext, getInnerWidth, BAR_PADDING_LEFT, WIDTH, colors } from './searchField.style';
import { t } from '../../i18n';
import { MAX_TEXT_LENGTH_TO_SHOW } from './searchField.constants';

export default class SearchField extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
        },
        Bar: {
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
        },
        Label: {},
      },
      getInitialStyle(),
    );
  }

  _init() {
    this._style = defaultContext;
  }

  _build() {
    const label = this.tag('Label');

    label.on('txLoaded', () => {
      const labelInnerWidth = getInnerWidth(WIDTH[this._style.screenSize], BAR_PADDING_LEFT);
      const textWidth = label.finalW;
      if (textWidth > labelInnerWidth) {
        const diff = (textWidth - labelInnerWidth) * -1;
        label.x = diff;
      } else {
        label.x = BAR_PADDING_LEFT;
      }
    });
  }

  _detach() {
    this.tag('Label').removeAllListeners('txLoaded');
  }

  set searchQuery(value) {
    if (!value) {
      this.tag('Label').text.text = t('search.placeholder');
      this.tag('Label').text.textColor = colors.text_idle[defaultContext.colorMode];

      return;
    }

    this.tag('Label').text.text =
      value.length > MAX_TEXT_LENGTH_TO_SHOW ? value.slice(-MAX_TEXT_LENGTH_TO_SHOW) : value;
    this.tag('Label').text.textColor = colors.text_completed[defaultContext.colorMode];
  }
}
